import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex: 1;
  height: 100%;
`



// WEBPACK FOOTER //
// ./src/components/HeaderSidebarLayout/ContentWrapper.js